import { useAuth0 } from "@auth0/auth0-react";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { COMPETITIONS_API_BASEURL } from "~shared/constants";
import { useNotification } from "~hooks/useNotification";

/**
 * @deprecated This function is deprecated.
 * Please use `~hooks/apiHooks/useApi/useApi.ts` instead.
 */
export const useApi = () => {
  const { customerId } = useParams();
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const notification = useNotification();
  const BASE_API_URL = COMPETITIONS_API_BASEURL + `/v1/`;

  const fetchData = async ({ url, body = null, method = "GET", headers = {} }) => {
    try {
      const ID_TOKEN = await getIdTokenClaims();
      const accessToken = await getAccessTokenSilently();
      const requestProps = {
        method: method,
        headers: {
          Authorization: `Bearer ${ID_TOKEN?.__raw}`,
          "x-user-identity-token": accessToken,
        },
      };
      if (customerId) {
        requestProps.headers["x-customer-id"] = customerId;
      }
      requestProps.headers = {
        ...requestProps.headers,
        ...headers,
      };
      if (body) {
        requestProps.body = JSON.stringify(body);
      }
      const response = await fetch(BASE_API_URL + url, requestProps);
      if (!response.ok) {
        if (response.status === 403) {
          notification.error({
            message: "You are not authorized to perform this action.",
            placement: "bottomRight",
          });
          const body = await response.json();
          return { status: response.status, ok: response.ok, ...body };
        } else {
          const error = await response.text();
          notification.error({
            message: "Request error",
            description: error || "Unexpected error",
          });
          return { status: response.status, ok: response.ok };
        }
      }

      return await response.json();
    } catch (e) {
      notification.error({
        message: "Request error",
        description: e?.message,
      });
      throw e;
    }
  };

  const mutateData = async ({ url, data = null, method = "POST", imageType = null }) => {
    const ID_TOKEN = await getIdTokenClaims();
    const accessToken = await getAccessTokenSilently();

    const OPTIONS = {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ID_TOKEN?.__raw}`,
        "x-user-identity-token": accessToken,
        "x-customer-id": customerId,
      },
    };

    if (data) {
      OPTIONS.body = JSON.stringify(data);
    }

    if (imageType) {
      OPTIONS.headers["Content-Type"] = data?.type || "application/octet-stream";
      OPTIONS.body = data;
    }

    const response = await fetch(BASE_API_URL + url, OPTIONS);

    if (!response.ok) {
      if (response.status === 403) {
        notification.error({
          message: "You are not authorized to perform this action.",
          placement: "bottomRight",
        });
      } else {
        let errorMessage = "Request error";
        if (response.status === 400) {
          const json = await response.json();
          if (!isEmpty(json?.error?.message)) {
            errorMessage = json?.error?.message;
          }
        }

        notification.error({
          message: errorMessage,
          placement: "bottomRight",
        });
      }

      throw Error;
    }

    return response.json();
  };

  return {
    fetchData,
    mutateData,
  };
};
